import React, { useState } from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import { ServiceType } from '@/modules/plan/PlanSetup/EligibleServicesSection/EligibleServices.constants.ts';
import { Service } from '@/modules/plan/PlanSetup/EligibleServicesSection/EligibleServices.types.ts';

import { useServiceActions } from '../../hooks';
import TableHeaderWrapper from '../../TableHeaderWrapper';
import ServiceItem from '../ServicesTable/ServiceItem';

interface Props {
  total: number;
  services: Service[];
  isDisabled?: boolean;
  parentId?: number;
}

const ITEMS_PER_PAGE = 15;

const ServicesTable: React.FC<Props> = ({
  total,
  services,
  isDisabled,
  parentId,
}) => {
  const { eligibleServicesIdsArray, handleServiceSelect } = useServiceActions();
  const [visibleServices, setVisibleServices] = useState(ITEMS_PER_PAGE);

  const handleLoadMore = () => {
    setVisibleServices((prevVisibleServices) => prevVisibleServices + ITEMS_PER_PAGE);
  };
  return (
    <>
      <Box height="1px" background="border1" margin={{ vertical: 'xs' }} />
      <Box pad="l" background="module" round="small">
        <Inscription
          weight="bold"
          color="textBody"
          style={{ whiteSpace: 'nowrap' }}
          lineHeight="20px"
        >
          Services: {total}
        </Inscription>
        <Box margin={{ top: 'm' }}>
          <TableHeaderWrapper>
            <Box width="50%"><Inscription size="12px" weight="bold">Service Name</Inscription></Box>
            <Box width="50%"><Inscription size="12px" weight="bold">Type</Inscription></Box>
          </TableHeaderWrapper>
        </Box>
        <Box width="100%" gap="xxs">
          {services?.slice(0, visibleServices)?.map((service) => (
            <Box key={service?.id}>
              <ServiceItem
                service={service}
                isChecked={eligibleServicesIdsArray?.includes(service?.id)}
                onSelect={handleServiceSelect}
                isDisabled={isDisabled || (!!parentId && service.serviceType === ServiceType.CARD)}
              />
            </Box>
          ))}
          {visibleServices < services?.length && (
            <Box align="center" margin={{ top: 'm' }}>
              <Inscription
                weight="bold"
                color="navigationAccent"
                cursor='pointer'
                onClick={handleLoadMore}
              >
                Load More
              </Inscription>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};

export default ServicesTable;
